import VerifyOTPContainer from 'containers/VerifyOTPContainer';
import React from 'react';

type Props = {};

export default function VerifyOTPPage({}: Props) {
  return <VerifyOTPContainer />;
}
